export default "__VITE_ASSET__Bu8RtgJz__"